module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_35.dot-2f937c93397060eb77a8115665070ba1.svg";